import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import React from 'react'

const styles = {
    dialog: {
        "& .MuiBackdrop-root": {
            backgroundColor: "rgb(0,0,0,0.3)",
        },
    },
    title: { backgroundColor: "grey" },
    content: { textAlign: "center" }
}
const PopUp = ({ open, setClose, msg }) => {

    const handleClose = () => {
        setClose(false)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={"sm"}
            fullWidth
            sx={styles.dialog}
        >
            <DialogTitle sx={styles.title}>Atencion</DialogTitle>
            <Divider />
            <DialogContent sx={styles.content}>
                {msg}
            </DialogContent>
            <DialogActions>
                <Button autoFocus color='success' variant='text' onClick={() => handleClose()}>Aceptar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default PopUp